// English strings of the app shell (decision D13: English first).

export const strings = {
  title: "Propulsion Systems Simulator",
  skip: "Skip to the controls",
  panels: "Panels",
  stage: "Engine view",
  collapse: "Collapse",
  expand: "Expand",
  featureFailed: "This panel failed to load.",
} as const;
